import { GRAAL_API_URL } from "../../config";
import useStore from "../../context/useStore";
import { graalApiAxiosInstance } from "../../middlewares/useApiAuthMiddleware";

const useLeadAutoTaskService = () => {
  const [state] = useStore();

  const leadAutoTaskServiceActions = {
    postTask: (leadId, taskData) => {
      return graalApiAxiosInstance
        .post(`${GRAAL_API_URL}new-leads/${leadId}/ajouter-tache`, {
          nom: taskData.nom,
          commentaire: taskData.commentaire || null,
          ordre: taskData.ordre || null,
          creeePar: state.auth.user.id,
        })
        .then((res) => res.data);
    },
    patchTask: (leadId, taskId, taskData) => {
      return graalApiAxiosInstance
        .put(`${GRAAL_API_URL}new-leads/${leadId}/modifier-tache`, {
          id: taskId,
          nom: taskData.nom,
          commentaire: taskData.commentaire || null,
          ordre: taskData.ordre || null,
          modifieePar: state.auth.user.id,
        })
        .then((res) => res.data);
    },
    patchTaskStatus: (leadId, taskId, statut) => {
      return graalApiAxiosInstance
        .patch(`${GRAAL_API_URL}new-leads/${leadId}/modifier-statut-tache`, {
          id: taskId,
          statut: statut,
          modifieePar: state.auth.user.id,
        })
        .then((res) => res.data);
    },
    deleteTask: (leadId, taskId) => {
      return graalApiAxiosInstance
        .delete(`${GRAAL_API_URL}new-leads/${leadId}/supprimer-tache/${taskId}`)
        .then((res) => res.data);
    },
  };

  return { leadAutoTaskServiceActions };
};

export default useLeadAutoTaskService;
